module.exports = __webpack_public_path__ + "static/media/BackgroundAuthModal.82fe15f5.svg";